var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExcelWindow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1198,
    height: 843,
    viewBox: "0 0 1198 843",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3014_24210)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1198,
    height: 843,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3014_24210)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 138.79,
    width: 149.778,
    height: 29.3488,
    fill: "#F2F3F8"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 138.79,
    width: 149.778,
    height: 29.3488,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.778,
    y: 138.79,
    width: 149.778,
    height: 29.3488,
    fill: "#F2F3F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.778,
    y: 138.79,
    width: 149.778,
    height: 29.3488,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.158 159.464L223.783 147.054H225.223L229.849 159.464H228.205L224.842 150.07C224.775 149.884 224.715 149.703 224.664 149.528C224.614 149.353 224.566 149.169 224.52 148.977H224.444C224.405 149.169 224.359 149.353 224.309 149.528C224.258 149.703 224.198 149.884 224.131 150.07L220.734 159.464H219.158ZM221.14 156.22L221.615 154.924H227.367L227.841 156.22H221.14Z",
    fill: "#232639"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.556,
    y: 138.79,
    width: 149.778,
    height: 29.3488,
    fill: "#F2F3F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.556,
    y: 138.79,
    width: 149.778,
    height: 29.3488,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.359 159.464V147.131H374.357C375.583 147.131 376.546 147.393 377.246 147.918C377.946 148.438 378.297 149.26 378.297 150.383C378.297 151.067 378.127 151.623 377.788 152.052C377.449 152.481 377.029 152.784 376.526 152.959V152.993C377.142 153.173 377.644 153.509 378.034 154.001C378.424 154.486 378.618 155.127 378.618 155.924C378.618 157.047 378.254 157.92 377.526 158.541C376.797 159.157 375.826 159.464 374.612 159.464H370.359ZM371.901 158.16H374.612C375.459 158.16 376.08 157.959 376.475 157.558C376.871 157.152 377.068 156.607 377.068 155.924C377.068 155.235 376.871 154.69 376.475 154.289C376.08 153.888 375.459 153.687 374.612 153.687H371.901V158.16ZM371.901 152.4H374.357C375.205 152.4 375.812 152.222 376.179 151.866C376.551 151.51 376.738 151.019 376.738 150.392C376.738 149.759 376.551 149.277 376.179 148.943C375.812 148.604 375.205 148.435 374.357 148.435H371.901V152.4Z",
    fill: "#232639"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 449.333,
    y: 138.79,
    width: 149.778,
    height: 29.3488,
    fill: "#F2F3F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 449.333,
    y: 138.79,
    width: 149.778,
    height: 29.3488,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.179 153.679V152.916C519.179 151.002 519.659 149.519 520.62 148.469C521.58 147.413 522.785 146.885 524.237 146.885C525.688 146.885 526.823 147.283 527.642 148.079C528.461 148.876 528.87 149.844 528.87 150.985V151.078H527.295V150.985C527.295 150.183 527.041 149.525 526.532 149.011C526.03 148.492 525.264 148.232 524.237 148.232C523.22 148.232 522.387 148.616 521.738 149.384C521.094 150.152 520.772 151.329 520.772 152.916V153.679C520.772 155.147 521.094 156.296 521.738 157.126C522.387 157.951 523.22 158.363 524.237 158.363C525.208 158.363 525.939 158.103 526.431 157.584C526.928 157.059 527.213 156.401 527.286 155.61L527.295 155.517H528.87L528.862 155.619C528.76 156.748 528.325 157.714 527.557 158.516C526.795 159.312 525.688 159.71 524.237 159.71C522.774 159.71 521.565 159.185 520.611 158.134C519.657 157.078 519.179 155.593 519.179 153.679Z",
    fill: "#232639"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 599.111,
    y: 138.79,
    width: 149.778,
    height: 29.3488,
    fill: "#F2F3F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 599.111,
    y: 138.79,
    width: 149.778,
    height: 29.3488,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.415 159.464V147.131H673.006C674.582 147.131 675.887 147.653 676.92 148.698C677.959 149.742 678.479 151.149 678.479 152.916V153.679C678.479 155.446 677.959 156.852 676.92 157.897C675.887 158.942 674.582 159.464 673.006 159.464H669.415ZM670.99 158.16H673.006C674.198 158.16 675.141 157.765 675.836 156.974C676.536 156.183 676.886 155.085 676.886 153.679V152.916C676.886 151.51 676.536 150.412 675.836 149.621C675.135 148.83 674.192 148.435 673.006 148.435H670.99V158.16Z",
    fill: "#232639"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 748.889,
    y: 138.79,
    width: 149.778,
    height: 29.3488,
    fill: "#F2F3F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 748.889,
    y: 138.79,
    width: 149.778,
    height: 29.3488,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("path", {
    d: "M820.192 159.464V147.131H827.816V148.435H821.768V152.45H827.029V153.755H821.768V158.16H827.901V159.464H820.192Z",
    fill: "#232639"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 898.667,
    y: 138.79,
    width: 149.778,
    height: 29.3488,
    fill: "#F2F3F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 898.667,
    y: 138.79,
    width: 149.778,
    height: 29.3488,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("path", {
    d: "M969.97 159.464V147.131H977.45V148.435H971.546V152.688H976.637V153.984H971.546V159.464H969.97Z",
    fill: "#232639"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1048.44,
    y: 138.79,
    width: 149.778,
    height: 29.3488,
    fill: "#F2F3F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1048.44,
    y: 138.79,
    width: 149.778,
    height: 29.3488,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1118.29 153.679V152.916C1118.29 151.013 1118.77 149.533 1119.72 148.477C1120.68 147.416 1121.92 146.885 1123.45 146.885C1124.83 146.885 1125.91 147.255 1126.69 147.995C1127.48 148.734 1127.91 149.615 1128 150.638L1128.01 150.739H1126.42V150.646C1126.42 150.059 1126.16 149.511 1125.64 149.003C1125.12 148.489 1124.39 148.232 1123.43 148.232C1122.36 148.232 1121.5 148.647 1120.85 149.477C1120.2 150.307 1119.88 151.454 1119.88 152.916V153.679C1119.88 155.141 1120.21 156.288 1120.86 157.118C1121.51 157.948 1122.42 158.363 1123.6 158.363C1124.22 158.363 1124.75 158.298 1125.19 158.168C1125.65 158.038 1126.07 157.832 1126.47 157.55V154.619H1123.43V153.323H1128.01V158.118C1127.63 158.502 1127.07 158.863 1126.32 159.202C1125.57 159.541 1124.66 159.71 1123.6 159.71C1121.98 159.71 1120.68 159.182 1119.72 158.126C1118.77 157.064 1118.29 155.582 1118.29 153.679Z",
    fill: "#232639"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1198.22,
    y: 138.79,
    width: 149.778,
    height: 29.3488,
    fill: "#F2F3F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1198.22,
    y: 138.79,
    width: 149.778,
    height: 29.3488,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    y: 168.139,
    width: 149.778,
    height: 31.2278,
    fill: "#F2F3F8"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 168.139,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3955 189.753V179.138L71.2951 180.434V178.91L75.7 177.249H75.9711V189.753H74.3955Z",
    fill: "#232639"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.778,
    y: 168.139,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.556,
    y: 168.139,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 449.333,
    y: 168.139,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 599.111,
    y: 168.139,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 748.889,
    y: 168.139,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 898.667,
    y: 168.139,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1048.44,
    y: 168.139,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1198.22,
    y: 168.139,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    y: 199.367,
    width: 149.778,
    height: 31.2278,
    fill: "#F2F3F8"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 199.367,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.7868 220.981V219.828L75.1494 215.059C75.7311 214.438 76.1716 213.885 76.4709 213.399C76.7759 212.908 76.9284 212.38 76.9284 211.815C76.9284 211.233 76.7335 210.736 76.3438 210.324C75.9598 209.906 75.4318 209.697 74.7598 209.697C74.0821 209.697 73.5089 209.917 73.0401 210.358C72.577 210.798 72.3455 211.422 72.3455 212.23V212.315H70.7868V212.23C70.7868 211.1 71.168 210.18 71.9304 209.468C72.6928 208.757 73.6359 208.401 74.7598 208.401C75.8723 208.401 76.7702 208.729 77.4536 209.384C78.1425 210.039 78.487 210.821 78.487 211.73C78.487 212.521 78.264 213.241 77.8178 213.89C77.3773 214.54 76.8323 215.212 76.1829 215.906L72.7352 219.617H78.8174V220.981H70.7868Z",
    fill: "#232639"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.778,
    y: 199.367,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.556,
    y: 199.367,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 449.333,
    y: 199.367,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 599.111,
    y: 199.367,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 748.889,
    y: 199.367,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 898.667,
    y: 199.367,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1048.44,
    y: 199.367,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1198.22,
    y: 199.367,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    y: 230.594,
    width: 149.778,
    height: 31.2278,
    fill: "#F2F3F8"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 230.594,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5327 248.989V248.905H72.066V248.989C72.066 249.684 72.2918 250.22 72.7436 250.599C73.2011 250.972 73.7997 251.158 74.5395 251.158C75.285 251.158 75.8808 250.969 76.3269 250.59C76.7787 250.212 77.0046 249.625 77.0046 248.828C77.0046 248.026 76.7505 247.425 76.2422 247.024C75.7396 246.617 75.0647 246.414 74.2176 246.414H73.218V245.143H74.1329C74.9122 245.143 75.5137 244.954 75.9372 244.576C76.3664 244.197 76.581 243.661 76.581 242.966C76.581 242.277 76.3975 241.766 76.0304 241.433C75.6633 241.094 75.1664 240.925 74.5395 240.925C73.8788 240.925 73.3564 241.094 72.9724 241.433C72.594 241.772 72.4048 242.258 72.4048 242.89V242.975H70.8715V242.89C70.8715 241.975 71.2104 241.204 71.8881 240.578C72.5714 239.945 73.4552 239.629 74.5395 239.629C75.5956 239.629 76.4624 239.931 77.1401 240.535C77.8178 241.134 78.1567 241.916 78.1567 242.882C78.1567 243.469 77.9985 244.02 77.6823 244.534C77.3717 245.047 76.8945 245.443 76.2507 245.719V245.753C76.9566 245.928 77.5242 246.284 77.9534 246.821C78.3826 247.357 78.5972 248.024 78.5972 248.82C78.5972 249.949 78.2131 250.839 77.4451 251.488C76.6827 252.132 75.7142 252.454 74.5395 252.454C73.3027 252.454 72.3257 252.132 71.6085 251.488C70.8913 250.844 70.5327 250.011 70.5327 248.989Z",
    fill: "#232639"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.778,
    y: 230.594,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.556,
    y: 230.594,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 449.333,
    y: 230.594,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 599.111,
    y: 230.594,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 748.889,
    y: 230.594,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 898.667,
    y: 230.594,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1048.44,
    y: 230.594,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1198.22,
    y: 230.594,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    y: 261.822,
    width: 149.778,
    height: 31.2278,
    fill: "#F2F3F8"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 261.822,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.9203 283.436V280.073V279.65V273.644H75.8271L72.0744 279.234H76.3354H76.9622H79.1224V280.531H70.287V279.48L75.9881 271.102H77.4027V283.436H75.9203Z",
    fill: "#232639"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.778,
    y: 261.822,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.556,
    y: 261.822,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 449.333,
    y: 261.822,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 599.111,
    y: 261.822,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 748.889,
    y: 261.822,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 898.667,
    y: 261.822,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1048.44,
    y: 261.822,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1198.22,
    y: 261.822,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    y: 293.05,
    width: 149.778,
    height: 31.2278,
    fill: "#F2F3F8"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 293.05,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.6936 311.572V311.479H72.2015V311.572C72.2015 312.204 72.4217 312.704 72.8622 313.071C73.3027 313.433 73.8929 313.613 74.6327 313.613C75.3725 313.613 75.9739 313.362 76.437 312.86C76.9058 312.357 77.1401 311.645 77.1401 310.725C77.1401 309.804 76.9058 309.11 76.437 308.641C75.9739 308.167 75.3781 307.929 74.6496 307.929C74.1357 307.929 73.6811 308.023 73.2858 308.209C72.8961 308.395 72.5375 308.655 72.21 308.988L71.1172 308.488L71.7441 302.33H78.0635V303.719H73.0232L72.6505 307.286C72.9272 307.11 73.2547 306.955 73.6331 306.82C74.0171 306.684 74.4379 306.616 74.8953 306.616C75.9514 306.616 76.8493 306.975 77.5891 307.692C78.3346 308.409 78.7073 309.42 78.7073 310.725C78.7073 312.029 78.3204 313.054 77.5467 313.8C76.7787 314.54 75.8073 314.91 74.6327 314.91C73.3846 314.91 72.4161 314.596 71.7271 313.969C71.0381 313.337 70.6936 312.538 70.6936 311.572Z",
    fill: "#232639"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.778,
    y: 293.05,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.556,
    y: 293.05,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 449.333,
    y: 293.05,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 599.111,
    y: 293.05,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 748.889,
    y: 293.05,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 898.667,
    y: 293.05,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1048.44,
    y: 293.05,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1198.22,
    y: 293.05,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    y: 324.278,
    width: 149.778,
    height: 31.2278,
    fill: "#F2F3F8"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 324.278,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.6174 340.69V340.436C70.6174 338.285 71.1906 336.559 72.337 335.261C73.4834 333.962 75.1099 333.312 77.2164 333.312H77.3858V334.608H77.2164C75.652 334.608 74.4181 335.071 73.5145 335.997C72.6109 336.924 72.1591 338.378 72.1591 340.36V340.767C72.1591 342.252 72.4161 343.302 72.93 343.918C73.4439 344.534 74.0962 344.841 74.8868 344.841C75.6718 344.841 76.2817 344.593 76.7166 344.096C77.1514 343.593 77.3689 342.884 77.3689 341.97C77.3689 341.055 77.1514 340.352 76.7166 339.86C76.2817 339.369 75.6718 339.123 74.8868 339.123C74.1527 339.123 73.506 339.372 72.9469 339.869C72.3879 340.36 72.1083 341.058 72.1083 341.961H71.5238C71.5238 340.724 71.8598 339.728 72.5319 338.971C73.2039 338.208 74.0962 337.827 75.2087 337.827C76.3326 337.827 77.2333 338.208 77.911 338.971C78.5887 339.728 78.9275 340.727 78.9275 341.97C78.9275 343.212 78.5463 344.217 77.7839 344.985C77.0215 345.753 76.0558 346.137 74.8868 346.137C73.7065 346.137 72.6985 345.711 71.8626 344.858C71.0325 344 70.6174 342.611 70.6174 340.69Z",
    fill: "#232639"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.778,
    y: 324.278,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.556,
    y: 324.278,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 449.333,
    y: 324.278,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 599.111,
    y: 324.278,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 748.889,
    y: 324.278,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 898.667,
    y: 324.278,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1048.44,
    y: 324.278,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1198.22,
    y: 324.278,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    y: 355.506,
    width: 149.778,
    height: 31.2278,
    fill: "#F2F3F8"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 355.506,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.337 377.12L77.0131 366.107H70.5157V364.786H78.6565V365.658L73.9465 377.12H72.337Z",
    fill: "#232639"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.778,
    y: 355.506,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.556,
    y: 355.506,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 449.333,
    y: 355.506,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 599.111,
    y: 355.506,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 748.889,
    y: 355.506,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 898.667,
    y: 355.506,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1048.44,
    y: 355.506,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1198.22,
    y: 355.506,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    y: 386.733,
    width: 149.778,
    height: 31.2278,
    fill: "#F2F3F8"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 386.733,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.7275 405.086C70.7275 404.34 70.9308 403.705 71.3374 403.18C71.7441 402.655 72.258 402.271 72.8792 402.028V401.994C72.3991 401.757 71.9841 401.393 71.6339 400.901C71.2894 400.41 71.1172 399.82 71.1172 399.131C71.1172 398.114 71.4617 397.301 72.1507 396.691C72.8453 396.076 73.698 395.768 74.7089 395.768C75.7198 395.768 76.5669 396.073 77.2503 396.683C77.9392 397.293 78.2837 398.109 78.2837 399.131C78.2837 399.825 78.1087 400.418 77.7585 400.91C77.414 401.395 77.0018 401.757 76.5217 401.994V402.028C77.143 402.271 77.6569 402.655 78.0635 403.18C78.4701 403.705 78.6734 404.34 78.6734 405.086C78.6734 406.198 78.2922 407.063 77.5298 407.678C76.7674 408.288 75.8271 408.593 74.7089 408.593C73.5907 408.593 72.6476 408.288 71.8796 407.678C71.1115 407.063 70.7275 406.198 70.7275 405.086ZM72.2693 404.993C72.2693 405.682 72.4895 406.238 72.93 406.662C73.3761 407.085 73.9691 407.297 74.7089 407.297C75.4431 407.297 76.0276 407.085 76.4624 406.662C76.9029 406.238 77.1232 405.685 77.1232 405.001C77.1232 404.307 76.9029 403.747 76.4624 403.324C76.0219 402.9 75.4374 402.689 74.7089 402.689C73.9748 402.689 73.3846 402.9 72.9385 403.324C72.4923 403.747 72.2693 404.304 72.2693 404.993ZM72.625 399.215C72.625 399.842 72.8171 400.362 73.2011 400.774C73.5851 401.181 74.0877 401.384 74.7089 401.384C75.3245 401.384 75.8215 401.181 76.1998 400.774C76.5782 400.362 76.7674 399.842 76.7674 399.215C76.7674 398.583 76.581 398.066 76.2083 397.665C75.8356 397.264 75.3358 397.064 74.7089 397.064C74.0821 397.064 73.5766 397.264 73.1926 397.665C72.8142 398.061 72.625 398.577 72.625 399.215Z",
    fill: "#232639"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.778,
    y: 386.733,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.556,
    y: 386.733,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 449.333,
    y: 386.733,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 599.111,
    y: 386.733,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 748.889,
    y: 386.733,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 898.667,
    y: 386.733,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1048.44,
    y: 386.733,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1198.22,
    y: 386.733,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    y: 417.961,
    width: 149.778,
    height: 31.2278,
    fill: "#F2F3F8"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 417.961,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4903 431.087C70.4903 429.867 70.8715 428.882 71.6339 428.131C72.3963 427.374 73.362 426.996 74.531 426.996C75.7057 426.996 76.7109 427.425 77.5467 428.283C78.3826 429.136 78.8005 430.522 78.8005 432.442V432.697C78.8005 434.707 78.2273 436.359 77.0808 437.652C75.9344 438.94 74.308 439.584 72.2015 439.584H72.0321V438.287H72.193C73.7573 438.287 74.9913 437.83 75.8949 436.915C76.8041 435.995 77.2587 434.614 77.2587 432.773V432.366C77.2587 430.881 76.9989 429.831 76.4794 429.215C75.9655 428.599 75.316 428.292 74.531 428.292C73.7461 428.292 73.1361 428.534 72.7013 429.02C72.2664 429.506 72.049 430.195 72.049 431.087C72.049 431.974 72.2636 432.657 72.6928 433.137C73.1277 433.611 73.7404 433.849 74.531 433.849C75.2596 433.849 75.9034 433.609 76.4624 433.129C77.0215 432.649 77.3011 431.971 77.3011 431.096H77.8941C77.8941 432.31 77.5552 433.29 76.8775 434.035C76.2055 434.775 75.3132 435.145 74.2007 435.145C73.0881 435.145 72.1902 434.775 71.5069 434.035C70.8292 433.29 70.4903 432.307 70.4903 431.087Z",
    fill: "#232639"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.778,
    y: 417.961,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.556,
    y: 417.961,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 449.333,
    y: 417.961,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 599.111,
    y: 417.961,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 748.889,
    y: 417.961,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 898.667,
    y: 417.961,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1048.44,
    y: 417.961,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1198.22,
    y: 417.961,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    y: 449.189,
    width: 149.778,
    height: 31.2278,
    fill: "#F2F3F8"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 449.189,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3955 470.803V460.189L66.2951 461.485V459.96L70.7 458.3H70.9711V470.803H69.3955ZM75.4439 466.923V462.349C75.4439 461.101 75.7883 460.101 76.4773 459.35C77.1663 458.599 78.1207 458.223 79.3406 458.223C80.5547 458.223 81.5091 458.599 82.2038 459.35C82.8984 460.101 83.2457 461.101 83.2457 462.349V466.923C83.2457 468.171 82.8984 469.171 82.2038 469.922C81.5091 470.673 80.5547 471.049 79.3406 471.049C78.1207 471.049 77.1663 470.673 76.4773 469.922C75.7883 469.171 75.4439 468.171 75.4439 466.923ZM77.0279 467.008C77.0279 467.81 77.2171 468.468 77.5955 468.982C77.9739 469.495 78.5556 469.752 79.3406 469.752C80.1312 469.752 80.7157 469.495 81.0941 468.982C81.4724 468.468 81.6616 467.81 81.6616 467.008V462.264C81.6616 461.462 81.4724 460.804 81.0941 460.29C80.7157 459.776 80.1312 459.519 79.3406 459.519C78.5556 459.519 77.9739 459.776 77.5955 460.29C77.2171 460.804 77.0279 461.462 77.0279 462.264V467.008Z",
    fill: "#232639"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.778,
    y: 449.189,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.556,
    y: 449.189,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 449.333,
    y: 449.189,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 599.111,
    y: 449.189,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 748.889,
    y: 449.189,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 898.667,
    y: 449.189,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1048.44,
    y: 449.189,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1198.22,
    y: 449.189,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    y: 480.417,
    width: 149.778,
    height: 31.2278,
    fill: "#F2F3F8"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 480.417,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3955 502.031V491.416L66.2951 492.712V491.188L70.7 489.527H70.9711V502.031H69.3955ZM79.0356 502.031V491.416L75.9352 492.712V491.188L80.3401 489.527H80.6112V502.031H79.0356Z",
    fill: "#232639"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.778,
    y: 480.417,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.556,
    y: 480.417,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 449.333,
    y: 480.417,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 599.111,
    y: 480.417,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 748.889,
    y: 480.417,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 898.667,
    y: 480.417,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1048.44,
    y: 480.417,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1198.22,
    y: 480.417,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    y: 511.645,
    width: 149.778,
    height: 31.2278,
    fill: "#F2F3F8"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 511.645,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3955 533.258V522.644L66.2951 523.94V522.415L70.7 520.755H70.9711V533.258H69.3955ZM75.4269 533.258V532.106L79.7895 527.337C80.3712 526.716 80.8117 526.162 81.111 525.677C81.416 525.185 81.5684 524.657 81.5684 524.093C81.5684 523.511 81.3736 523.014 80.9839 522.602C80.5999 522.184 80.0719 521.975 79.3998 521.975C78.7222 521.975 78.149 522.195 77.6802 522.636C77.2171 523.076 76.9856 523.7 76.9856 524.508V524.593H75.4269V524.508C75.4269 523.378 75.8081 522.458 76.5705 521.746C77.3329 521.035 78.276 520.679 79.3998 520.679C80.5124 520.679 81.4103 521.006 82.0937 521.662C82.7826 522.317 83.1271 523.099 83.1271 524.008C83.1271 524.799 82.9041 525.519 82.4579 526.168C82.0174 526.818 81.4724 527.49 80.823 528.184L77.3753 531.895H83.4575V533.258H75.4269Z",
    fill: "#232639"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.778,
    y: 511.645,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.556,
    y: 511.645,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 449.333,
    y: 511.645,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 599.111,
    y: 511.645,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 748.889,
    y: 511.645,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 898.667,
    y: 511.645,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1048.44,
    y: 511.645,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1198.22,
    y: 511.645,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    y: 542.872,
    width: 149.778,
    height: 31.2278,
    fill: "#F2F3F8"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 542.872,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3955 564.486V553.872L66.2951 555.168V553.643L70.7 551.983H70.9711V564.486H69.3955ZM75.1728 561.267V561.182H76.706V561.267C76.706 561.962 76.9319 562.498 77.3837 562.877C77.8412 563.249 78.4398 563.436 79.1796 563.436C79.9251 563.436 80.5209 563.247 80.967 562.868C81.4188 562.49 81.6447 561.903 81.6447 561.106C81.6447 560.304 81.3906 559.703 80.8823 559.302C80.3797 558.895 79.7048 558.692 78.8577 558.692H77.8581V557.421H78.773C79.5523 557.421 80.1538 557.232 80.5773 556.854C81.0065 556.475 81.2211 555.939 81.2211 555.244C81.2211 554.555 81.0376 554.044 80.6705 553.711C80.3034 553.372 79.8065 553.203 79.1796 553.203C78.5189 553.203 77.9965 553.372 77.6125 553.711C77.2341 554.05 77.0449 554.536 77.0449 555.168V555.253H75.5116V555.168C75.5116 554.253 75.8505 553.482 76.5282 552.855C77.2115 552.223 78.0953 551.907 79.1796 551.907C80.2357 551.907 81.1025 552.209 81.7802 552.813C82.4579 553.412 82.7968 554.194 82.7968 555.16C82.7968 555.747 82.6386 556.297 82.3224 556.811C82.0118 557.325 81.5346 557.721 80.8908 557.997V558.031C81.5967 558.206 82.1642 558.562 82.5934 559.099C83.0226 559.635 83.2372 560.301 83.2372 561.098C83.2372 562.227 82.8532 563.117 82.0852 563.766C81.3228 564.41 80.3543 564.732 79.1796 564.732C77.9428 564.732 76.9658 564.41 76.2486 563.766C75.5314 563.122 75.1728 562.289 75.1728 561.267Z",
    fill: "#232639"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.778,
    y: 542.872,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.556,
    y: 542.872,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 449.333,
    y: 542.872,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 599.111,
    y: 542.872,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 748.889,
    y: 542.872,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 898.667,
    y: 542.872,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1048.44,
    y: 542.872,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1198.22,
    y: 542.872,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    y: 574.1,
    width: 149.778,
    height: 31.2278,
    fill: "#F2F3F8"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 574.1,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3955 595.714V585.1L66.2951 586.396V584.871L70.7 583.211H70.9711V595.714H69.3955ZM80.5604 595.714V592.351V591.927V585.921H80.4672L76.7145 591.512H80.9755H81.6023H83.7625V592.808H74.9271V591.758L80.6282 583.38H82.0428V595.714H80.5604Z",
    fill: "#232639"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.778,
    y: 574.1,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.556,
    y: 574.1,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 449.333,
    y: 574.1,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 599.111,
    y: 574.1,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 748.889,
    y: 574.1,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 898.667,
    y: 574.1,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1048.44,
    y: 574.1,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1198.22,
    y: 574.1,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    y: 605.328,
    width: 149.778,
    height: 31.2278,
    fill: "#F2F3F8"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 605.328,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3955 626.942V616.328L66.2951 617.624V616.099L70.7 614.438H70.9711V626.942H69.3955ZM75.3337 623.85V623.757H76.8416V623.85C76.8416 624.482 77.0618 624.982 77.5023 625.349C77.9428 625.711 78.533 625.891 79.2728 625.891C80.0126 625.891 80.614 625.64 81.0771 625.137C81.5459 624.635 81.7802 623.923 81.7802 623.003C81.7802 622.082 81.5459 621.388 81.0771 620.919C80.614 620.444 80.0182 620.207 79.2897 620.207C78.7758 620.207 78.3212 620.3 77.9259 620.487C77.5362 620.673 77.1776 620.933 76.8501 621.266L75.7573 620.766L76.3841 614.608H82.7036V615.997H77.6633L77.2905 619.563C77.5673 619.388 77.8948 619.233 78.2732 619.098C78.6572 618.962 79.0779 618.894 79.5354 618.894C80.5914 618.894 81.4894 619.253 82.2292 619.97C82.9746 620.687 83.3474 621.698 83.3474 623.003C83.3474 624.307 82.9605 625.332 82.1868 626.078C81.4188 626.818 80.4474 627.187 79.2728 627.187C78.0247 627.187 77.0562 626.874 76.3672 626.247C75.6782 625.615 75.3337 624.816 75.3337 623.85Z",
    fill: "#232639"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.778,
    y: 605.328,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.556,
    y: 605.328,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 449.333,
    y: 605.328,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 599.111,
    y: 605.328,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 748.889,
    y: 605.328,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 898.667,
    y: 605.328,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1048.44,
    y: 605.328,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1198.22,
    y: 605.328,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    y: 636.556,
    width: 149.778,
    height: 31.2278,
    fill: "#F2F3F8"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 636.556,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3955 658.17V647.555L66.2951 648.851V647.327L70.7 645.666H70.9711V658.17H69.3955ZM75.2575 652.968V652.714C75.2575 650.563 75.8307 648.837 76.9771 647.538C78.1235 646.239 79.75 645.59 81.8565 645.59H82.0259V646.886H81.8565C80.2921 646.886 79.0582 647.349 78.1546 648.275C77.251 649.202 76.7992 650.656 76.7992 652.638V653.045C76.7992 654.53 77.0562 655.58 77.5701 656.196C78.084 656.811 78.7363 657.119 79.5269 657.119C80.3119 657.119 80.9218 656.871 81.3567 656.374C81.7915 655.871 82.0089 655.162 82.0089 654.247C82.0089 653.333 81.7915 652.629 81.3567 652.138C80.9218 651.647 80.3119 651.401 79.5269 651.401C78.7928 651.401 78.1461 651.65 77.587 652.147C77.0279 652.638 76.7484 653.335 76.7484 654.239H76.1639C76.1639 653.002 76.4999 652.005 77.172 651.249C77.844 650.486 78.7363 650.105 79.8488 650.105C80.9726 650.105 81.8734 650.486 82.5511 651.249C83.2288 652.005 83.5676 653.005 83.5676 654.247C83.5676 655.49 83.1864 656.495 82.424 657.263C81.6616 658.031 80.6959 658.415 79.5269 658.415C78.3466 658.415 77.3386 657.989 76.5027 657.136C75.6726 656.278 75.2575 654.888 75.2575 652.968Z",
    fill: "#232639"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.778,
    y: 636.556,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.556,
    y: 636.556,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 449.333,
    y: 636.556,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 599.111,
    y: 636.556,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 748.889,
    y: 636.556,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 898.667,
    y: 636.556,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1048.44,
    y: 636.556,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1198.22,
    y: 636.556,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    y: 667.783,
    width: 149.778,
    height: 31.2278,
    fill: "#F2F3F8"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 667.783,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3955 689.397V678.783L66.2951 680.079V678.554L70.7 676.894H70.9711V689.397H69.3955ZM76.9771 689.397L81.6532 678.385H75.1558V677.063H83.2965V677.936L78.5866 689.397H76.9771Z",
    fill: "#232639"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.778,
    y: 667.783,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.556,
    y: 667.783,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 449.333,
    y: 667.783,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 599.111,
    y: 667.783,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 748.889,
    y: 667.783,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 898.667,
    y: 667.783,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1048.44,
    y: 667.783,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1198.22,
    y: 667.783,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    y: 699.011,
    width: 149.778,
    height: 31.2278,
    fill: "#F2F3F8"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 699.011,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3955 720.625V710.011L66.2951 711.307V709.782L70.7 708.122H70.9711V720.625H69.3955ZM75.3676 717.364C75.3676 716.618 75.5709 715.983 75.9775 715.458C76.3841 714.933 76.8981 714.549 77.5193 714.306V714.272C77.0392 714.035 76.6242 713.67 76.274 713.179C75.9295 712.688 75.7573 712.098 75.7573 711.409C75.7573 710.392 76.1018 709.579 76.7908 708.969C77.4854 708.353 78.3381 708.046 79.349 708.046C80.3599 708.046 81.207 708.351 81.8903 708.96C82.5793 709.57 82.9238 710.386 82.9238 711.409C82.9238 712.103 82.7487 712.696 82.3986 713.188C82.0541 713.673 81.6419 714.035 81.1618 714.272V714.306C81.783 714.549 82.297 714.933 82.7036 715.458C83.1102 715.983 83.3135 716.618 83.3135 717.364C83.3135 718.476 82.9323 719.34 82.1699 719.956C81.4075 720.566 80.4672 720.871 79.349 720.871C78.2308 720.871 77.2877 720.566 76.5197 719.956C75.7516 719.34 75.3676 718.476 75.3676 717.364ZM76.9094 717.271C76.9094 717.96 77.1296 718.516 77.5701 718.939C78.0162 719.363 78.6092 719.575 79.349 719.575C80.0832 719.575 80.6677 719.363 81.1025 718.939C81.543 718.516 81.7633 717.962 81.7633 717.279C81.7633 716.584 81.543 716.025 81.1025 715.602C80.662 715.178 80.0775 714.966 79.349 714.966C78.6149 714.966 78.0247 715.178 77.5786 715.602C77.1324 716.025 76.9094 716.582 76.9094 717.271ZM77.2651 711.493C77.2651 712.12 77.4571 712.64 77.8412 713.052C78.2252 713.459 78.7278 713.662 79.349 713.662C79.9646 713.662 80.4616 713.459 80.8399 713.052C81.2183 712.64 81.4075 712.12 81.4075 711.493C81.4075 710.861 81.2211 710.344 80.8484 709.943C80.4757 709.542 79.9759 709.342 79.349 709.342C78.7222 709.342 78.2167 709.542 77.8327 709.943C77.4543 710.338 77.2651 710.855 77.2651 711.493Z",
    fill: "#232639"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.778,
    y: 699.011,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.556,
    y: 699.011,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 449.333,
    y: 699.011,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 599.111,
    y: 699.011,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 748.889,
    y: 699.011,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 898.667,
    y: 699.011,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1048.44,
    y: 699.011,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1198.22,
    y: 699.011,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    y: 730.239,
    width: 149.778,
    height: 31.2278,
    fill: "#F2F3F8"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 730.239,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3955 751.853V741.239L66.2951 742.535V741.01L70.7 739.35H70.9711V751.853H69.3955ZM75.1304 743.365C75.1304 742.145 75.5116 741.16 76.274 740.408C77.0364 739.652 78.0021 739.273 79.1711 739.273C80.3458 739.273 81.351 739.703 82.1868 740.561C83.0226 741.414 83.4406 742.8 83.4406 744.72V744.974C83.4406 746.985 82.8673 748.637 81.7209 749.93C80.5745 751.218 78.9481 751.861 76.8416 751.861H76.6722V750.565H76.8331C78.3974 750.565 79.6314 750.108 80.535 749.193C81.4442 748.272 81.8988 746.892 81.8988 745.051V744.644C81.8988 743.159 81.639 742.108 81.1195 741.493C80.6056 740.877 79.9561 740.569 79.1711 740.569C78.3861 740.569 77.7762 740.812 77.3414 741.298C76.9065 741.784 76.6891 742.473 76.6891 743.365C76.6891 744.252 76.9037 744.935 77.3329 745.415C77.7678 745.889 78.3805 746.126 79.1711 746.126C79.8996 746.126 80.5434 745.886 81.1025 745.406C81.6616 744.926 81.9412 744.249 81.9412 743.373H82.5341C82.5341 744.588 82.1953 745.567 81.5176 746.313C80.8456 747.053 79.9533 747.423 78.8408 747.423C77.7282 747.423 76.8303 747.053 76.147 746.313C75.4693 745.567 75.1304 744.585 75.1304 743.365Z",
    fill: "#232639"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.778,
    y: 730.239,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.556,
    y: 730.239,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 449.333,
    y: 730.239,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 599.111,
    y: 730.239,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 748.889,
    y: 730.239,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 898.667,
    y: 730.239,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1048.44,
    y: 730.239,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1198.22,
    y: 730.239,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    y: 761.467,
    width: 149.778,
    height: 31.2278,
    fill: "#F2F3F8"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 761.467,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7868 783.081V781.929L70.1494 777.159C70.7311 776.538 71.1716 775.985 71.4709 775.499C71.7759 775.008 71.9284 774.48 71.9284 773.915C71.9284 773.333 71.7335 772.836 71.3438 772.424C70.9598 772.006 70.4318 771.797 69.7598 771.797C69.0821 771.797 68.5089 772.017 68.0401 772.458C67.577 772.898 67.3455 773.522 67.3455 774.33V774.415H65.7868V774.33C65.7868 773.201 66.168 772.28 66.9304 771.568C67.6928 770.857 68.6359 770.501 69.7598 770.501C70.8723 770.501 71.7702 770.829 72.4536 771.484C73.1425 772.139 73.487 772.921 73.487 773.83C73.487 774.621 73.264 775.341 72.8178 775.99C72.3773 776.64 71.8323 777.312 71.1829 778.007L67.7352 781.717H73.8174V783.081H65.7868ZM75.4439 779.201V774.627C75.4439 773.378 75.7883 772.379 76.4773 771.628C77.1663 770.877 78.1207 770.501 79.3406 770.501C80.5547 770.501 81.5091 770.877 82.2038 771.628C82.8984 772.379 83.2457 773.378 83.2457 774.627V779.201C83.2457 780.449 82.8984 781.449 82.2038 782.2C81.5091 782.951 80.5547 783.326 79.3406 783.326C78.1207 783.326 77.1663 782.951 76.4773 782.2C75.7883 781.449 75.4439 780.449 75.4439 779.201ZM77.0279 779.286C77.0279 780.088 77.2171 780.745 77.5955 781.259C77.9739 781.773 78.5556 782.03 79.3406 782.03C80.1312 782.03 80.7157 781.773 81.0941 781.259C81.4724 780.745 81.6616 780.088 81.6616 779.286V774.542C81.6616 773.74 81.4724 773.082 81.0941 772.568C80.7157 772.054 80.1312 771.797 79.3406 771.797C78.5556 771.797 77.9739 772.054 77.5955 772.568C77.2171 773.082 77.0279 773.74 77.0279 774.542V779.286Z",
    fill: "#232639"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.778,
    y: 761.467,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.556,
    y: 761.467,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 449.333,
    y: 761.467,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 599.111,
    y: 761.467,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 748.889,
    y: 761.467,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 898.667,
    y: 761.467,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1048.44,
    y: 761.467,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1198.22,
    y: 761.467,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    y: 792.695,
    width: 149.778,
    height: 31.2278,
    fill: "#F2F3F8"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 792.695,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7868 814.308V813.156L70.1494 808.387C70.7311 807.766 71.1716 807.213 71.4709 806.727C71.7759 806.236 71.9284 805.708 71.9284 805.143C71.9284 804.561 71.7335 804.064 71.3438 803.652C70.9598 803.234 70.4318 803.025 69.7598 803.025C69.0821 803.025 68.5089 803.245 68.0401 803.686C67.577 804.126 67.3455 804.75 67.3455 805.558V805.643H65.7868V805.558C65.7868 804.428 66.168 803.508 66.9304 802.796C67.6928 802.085 68.6359 801.729 69.7598 801.729C70.8723 801.729 71.7702 802.056 72.4536 802.712C73.1425 803.367 73.487 804.149 73.487 805.058C73.487 805.849 73.264 806.569 72.8178 807.218C72.3773 807.868 71.8323 808.54 71.1829 809.234L67.7352 812.945H73.8174V814.308H65.7868ZM79.0356 814.308V803.694L75.9352 804.99V803.465L80.3401 801.805H80.6112V814.308H79.0356Z",
    fill: "#232639"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.778,
    y: 792.695,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.556,
    y: 792.695,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 449.333,
    y: 792.695,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 599.111,
    y: 792.695,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 748.889,
    y: 792.695,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 898.667,
    y: 792.695,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1048.44,
    y: 792.695,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1198.22,
    y: 792.695,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    y: 823.922,
    width: 149.778,
    height: 31.2278,
    fill: "#F2F3F8"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 823.922,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7868 845.536V844.384L70.1494 839.615C70.7311 838.994 71.1716 838.44 71.4709 837.955C71.7759 837.463 71.9284 836.935 71.9284 836.371C71.9284 835.789 71.7335 835.292 71.3438 834.88C70.9598 834.462 70.4318 834.253 69.7598 834.253C69.0821 834.253 68.5089 834.473 68.0401 834.914C67.577 835.354 67.3455 835.978 67.3455 836.786V836.87H65.7868V836.786C65.7868 835.656 66.168 834.736 66.9304 834.024C67.6928 833.312 68.6359 832.957 69.7598 832.957C70.8723 832.957 71.7702 833.284 72.4536 833.939C73.1425 834.594 73.487 835.377 73.487 836.286C73.487 837.076 73.264 837.797 72.8178 838.446C72.3773 839.095 71.8323 839.767 71.1829 840.462L67.7352 844.172H73.8174V845.536H65.7868ZM75.4269 845.536V844.384L79.7895 839.615C80.3712 838.994 80.8117 838.44 81.111 837.955C81.416 837.463 81.5684 836.935 81.5684 836.371C81.5684 835.789 81.3736 835.292 80.9839 834.88C80.5999 834.462 80.0719 834.253 79.3998 834.253C78.7222 834.253 78.149 834.473 77.6802 834.914C77.2171 835.354 76.9856 835.978 76.9856 836.786V836.87H75.4269V836.786C75.4269 835.656 75.8081 834.736 76.5705 834.024C77.3329 833.312 78.276 832.957 79.3998 832.957C80.5124 832.957 81.4103 833.284 82.0937 833.939C82.7826 834.594 83.1271 835.377 83.1271 836.286C83.1271 837.076 82.9041 837.797 82.4579 838.446C82.0174 839.095 81.4724 839.767 80.823 840.462L77.3753 844.172H83.4575V845.536H75.4269Z",
    fill: "#232639"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.778,
    y: 823.922,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.556,
    y: 823.922,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 449.333,
    y: 823.922,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 599.111,
    y: 823.922,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 748.889,
    y: 823.922,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 898.667,
    y: 823.922,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1048.44,
    y: 823.922,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1198.22,
    y: 823.922,
    width: 149.778,
    height: 31.2278,
    stroke: "#CBCDDC",
    strokeWidth: 1.73488
  })), /*#__PURE__*/React.createElement("mask", {
    id: "path-237-inside-1_3014_24210",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 83.274H1348V138.79H0V83.274Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 83.274H1348V138.79H0V83.274Z",
    fill: "#F2F3F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1348 137.055H0V140.525H1348V137.055Z",
    fill: "#CBCDDC",
    mask: "url(#path-237-inside-1_3014_24210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.879,
    y: 97.153,
    width: 27.758,
    height: 27.758,
    rx: 3.46976,
    fill: "#CBCDDC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.9857,
    y: 97.1531,
    width: 27.758,
    height: 27.758,
    rx: 3.46976,
    fill: "#CBCDDC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.093,
    y: 97.153,
    width: 27.758,
    height: 27.758,
    rx: 3.46976,
    fill: "#CBCDDC"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-242-inside-2_3014_24210",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 41.6372H1348V83.2743H0V41.6372Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 41.6372H1348V83.2743H0V41.6372Z",
    fill: "#F2F3F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1348 81.5394H0V85.0092H1348V81.5394Z",
    fill: "#CBCDDC",
    mask: "url(#path-242-inside-2_3014_24210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.879,
    y: 55.5162,
    width: 97.1531,
    height: 13.879,
    rx: 3.46976,
    fill: "#CBCDDC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.911,
    y: 55.5162,
    width: 74.5997,
    height: 13.879,
    rx: 3.46976,
    fill: "#CBCDDC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213.39,
    y: 55.5162,
    width: 86.7439,
    height: 13.879,
    rx: 3.46976,
    fill: "#CBCDDC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314.013,
    y: 55.5162,
    width: 105.828,
    height: 13.879,
    rx: 3.46976,
    fill: "#CBCDDC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 433.719,
    y: 55.5162,
    width: 52.0463,
    height: 13.879,
    rx: 3.46976,
    fill: "#CBCDDC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 499.645,
    y: 55.5162,
    width: 72.8649,
    height: 13.879,
    rx: 3.46976,
    fill: "#CBCDDC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 586.389,
    y: 55.5162,
    width: 79.8044,
    height: 13.879,
    rx: 3.46976,
    fill: "#CBCDDC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 680.072,
    y: 55.5162,
    width: 126.646,
    height: 13.879,
    rx: 3.46976,
    fill: "#CBCDDC"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-252-inside-3_3014_24210",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H1198V41.6371H0V0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 0H1198V41.6371H0V0Z",
    fill: "#1B7E55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1198 39.9022H0V43.3719H1198V39.9022Z",
    fill: "#CBCDDC",
    mask: "url(#path-252-inside-3_3014_24210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.879,
    y: 13.879,
    width: 13.879,
    height: 13.879,
    rx: 6.93951,
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.6976,
    y: 13.879,
    width: 13.879,
    height: 13.879,
    rx: 6.93951,
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.5163,
    y: 13.8791,
    width: 13.879,
    height: 13.879,
    rx: 6.93951,
    fill: "white",
    fillOpacity: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3014_24210"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1198,
    height: 843,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3014_24210"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1198,
    height: 704.21,
    fill: "white",
    transform: "translate(0 138.79)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcelWindow);
export default __webpack_public_path__ + "static/media/excel-window.49d45385c4508911d76ea3d13235e9ca.svg";
export { ForwardRef as ReactComponent };